import { Text, Title } from '@mantine/core'
import { CURRENT_TERMS_VERSION } from '@markku/utils'
import type { ReactNode } from 'react'

interface TermsVersion {
  pdfUrl: string
  effectiveDate: string
  content: ReactNode
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function TermsContent_20251103() {
  return (
    <>
      <Text size="sm">
        Nämä sopimusehdot ovat kiinteä osa Asiakkaan Markku.fi-huoltopalveluiden
        sopimusta, joka syntyy, kun Asiakas aktivoi palvelun tai muulla tavoin
        vahvistaa tilauksen.
      </Text>

      <Title order={4}>1. Yleiset ehdot</Title>

      <Title order={5}>1.1. Asiakkaan vastuut ja velvollisuudet</Title>
      <Text size="sm">
        Asiakkaalla tapahtuva alkukartoituskäynti on erittäin tärkeä onnistuneen
        yhteistyön kannalta. Sen perusteellaan saadaan huoltotöistä suunniteltua
        asiakkaalle parhaan arvon tuova kokonaisuus, jonka tuloksena Asiakkaan
        koti saadaan pidettyä ennakoivasti kunnossa ja mukavana asua.
        Alkukartoituksessa myös määritellään ja hyväksytetään mahdolliset työn
        laajuudesta tai muista ominaispiirteistä syntyvät kuukausimaksun päälle
        tulevat lisämaksut työtehtäväkohtaisesti.
      </Text>
      <Text size="sm">
        Asiakas vastaa, että kaikkiin sopimuksen mukaisiin työkohteisiin on
        esteetön ja turvallinen pääsy sovittuina aikoina. Asiakkaan velvollisuus
        on ilmoittaa Markku-sovelluksen kautta kaikista kohteessa tapahtuvista
        muutoksista, jotka voivat vaikuttaa Palvelun suorittamiseen (esim. uudet
        rakennelmat, istutukset, pihalla vapaana olevat lemmikkieläimet tai muut
        työskentelyyn vaikuttavat seikat). Haluamme varmistaa
        huoltohenkilöstölle eli Markuille mahdollisuuden turvalliseen
        työskentelyyn. Perustuen myös työturvallisuuslakiin pidätämme oikeuden
        olla tekemättä työtehtävää, jos se ei ole kohtuullisilla järjestelyillä
        mahdollista tehdä työturvallisesti. Asiakasta ei luonnollisesti silloin
        veloiteta ko. työstä, ellei työnteon este ilmene vasta kohteeseen
        saavuttaessa.
      </Text>
      <Text size="sm">
        Asiakkaalla on oikeus siirtää maksutta yhden (1) kerran jo sovittua
        seuraavaa Markku-pakettiinsa kuuluvaa huoltokäyntiä tai erikseen
        tilattua työtä, jos se tapahtuu viimeistään 2 viikkoa ennen sovittua
        tapahtumaa. Jos siirto tapahtuu lähempänä kuin 2 viikkoa sovitusta
        käynnistä tai useamman kerran samasta tapahtumasta, Palveluntarjoajalla
        on oikeus periä Asiakkaalta Palveluntarjoajan voimassa olevan hinnaston
        mukainen lisämaksu per siirtokerta. Uusia aika sovitaan yhdessä
        Asiakkaan ja Palveluntarjoajan kanssa käyttäen Markku-sovellusta.
      </Text>
      <Text size="sm">
        Asiakas ei saa suoraan solmia Markku.fi Palvelun ulkopuolisia työ- tai
        palvelusopimuksia Palveluntarjoajan henkilöstön tai sen käyttämien
        alihankkijoiden kanssa.
      </Text>

      <Title order={5}>1.2. Viestintä</Title>
      <Text size="sm">
        Kaikki Palveluun liittyvä viestintä, kuten palvelukäyntien sopiminen,
        palautteen antaminen ja mahdolliset reklamaatiot, tulee hoitaa
        Markku-sovelluksen viestintätoimintojen kautta. Tämä varmistaa
        tiedonkulun perillemenon, palvelutapahtumien dokumentoinnin ja
        laadukkaan asiakaspalvelun. Suorat yhteydenotot, kuten puhelinsoitot
        huoltohenkilöstölle, eivät ole sallittuja mm. jäljittävyyden ja
        työturvallisuuden takaamiseksi.
      </Text>

      <Title order={5}>1.3. Hinnoittelu, laskutus ja maksuehdot</Title>
      <Text size="sm">
        Kuukausimaksullinen Palvelu laskutetaan kuukausittain etukäteen
        Asiakkaan valitseman palvelupaketin mukaisesti. Asiakkaan erikseen
        tilaamat tai kohteen erityispiirteistä johtuvat lisätyöt (asiakkaan
        ennakkoon hyväksymät) veloitetaan tehdyn työn jälkeen ellei niitä ole
        sovittu lisättäväksi kuukausihintaan. Kaikki erikseen tilattavat huolto-
        ja korjaustehtävät kirjataan sähköiseen huoltokirjaan sekä Asiakkaan
        että Palveluntarjoajan nähtäville. Jos Asiakas ei ole itse hankkinut
        huoltotöihin liittyviä materiaaleja ja tarvikkeita (esim. IV-koneen
        suodattimet ja kiuaskivet) vaan tilaa ne Palveluntarjoajalta,
        veloitetaan ne Asiakkaalta tehdyn työn jälkeen.
      </Text>
      <Text size="sm">
        Jos Asiakkaalle toteutetaan hänen tilauksestaan töitä, jotka eivät kuulu
        sopimukseen, voidaan asiakkaalle antaa työstä kiinteähintainen tarjous
        tai se voi perustua Palveluntarjoajan voimassa olevan hinnaston
        mukaiseen tuntiveloitukseen. Jos Asiakas haluaa työtehtävän tapahtuvan
        Palveluntarjoajan normaalin työajan ma-pe 08:00 – 17:00 ulkopuolella ja
        pyhäpäivinä, siitä on sovittava erikseen, ja työstä veloitetaan
        hinnastossa mainittu korotettu maksu.
      </Text>
      <Text size="sm">
        Kuukausiveloitteisissa palveluissa matkakustannukset sisältyvät
        kuukausihintaan. Erikseen tilattavissa töissä matkakustannukset
        veloitetaan Palveluntarjoajan voimassa olevan hinnaston mukaisesti.
      </Text>
      <Text size="sm">
        Suoraveloitus luotto- (Credit) tai pankkikortilta (Debit) on
        lisämaksutonta. Sähköpostilla ja postitse (paperilasku) toimitetuista
        laskuista peritään voimassa olevan hinnaston mukainen laskutuslisä.
      </Text>
      <Text size="sm">
        Maksuehto on 14 päivää netto. Kaikki hinnaston hinnat sisältävät
        voimassa olevan arvonlisäveron. Viivästyneestä maksusta peritään
        korkolain mukainen viivästyskorko. Palveluntarjoajalla on oikeus
        keskeyttää Palvelun tuottaminen tai purkaa Sopimus kokonaan, mikäli
        Asiakas ei ole suorittanut erääntyneitä laskujaan maksumuistutuksista
        huolimatta.
      </Text>

      <Title order={5}>1.4. Hinnan- ja sisällönmuutokset</Title>
      <Text size="sm">
        Palveluntarjoaja pidättää oikeuden tarkistaa hintoja vuosittain. Hinnat
        on sidottu Tilastokeskuksen elinkustannusindeksiin (1951 = 100), mutta
        Palveluntarjoaja voi myös päättää sitä alemmasta korotuksesta.
        Palveluntarjoajalla on oikeus kehittää Palvelua ja tehdä muutoksia
        palvelupakettien sisältöön. Mikäli Asiakkaan tilaaman palvelupaketin
        sisältö muuttuu olennaisesti, ilmoitetaan siitä Asiakkaalle hyvissä
        ajoin. Samoin ilmoitetaan mahdollisesta muutoksen aiheuttamasta
        hinnankorotuksesta. Ilmoittaminen tapahtuu kirjallisesti
        Markku-sovelluksen kautta vähintään yksi (1) kuukautta ennen niiden
        voimaantuloa. Tällöin Asiakkaalla on oikeus irtisanoa Sopimus päättymään
        muutoksen voimaantulopäivään.
      </Text>

      <Title order={5}>1.5. Vastuunrajoitus</Title>
      <Text size="sm">
        Palveluntarjoajan vastuu rajoittuu Palvelun suorittamisessa
        aiheutettuihin välittömiin esinevahinkoihin, jotka johtuvat
        Palveluntarjoajan tai sen alihankkijan todistetusta huolimattomuudesta.
        Palveluntarjoaja ei vastaa välillisistä tai epäsuorista vahingoista.
      </Text>
      <Text size="sm">
        Palveluntarjoaja ei myöskään vastaa vahingoista, jotka johtuvat
        kiinteistön rakenteellisista tai piilevistä virheistä, puutteellisista
        tai virheellisistä lähtötiedoista tai Asiakkaan laiminlyönneistä.
      </Text>

      <Title order={5}>1.6. Sopimuksen voimassaolo ja irtisanominen</Title>
      <Text size="sm">
        Sopimus on toistaiseksi voimassa oleva. Molemmilla osapuolilla on yhden
        (1) täyden kalenterikuukauden irtisanomisaika, jolloin palvelu päättyy
        irtisanomishetkeä seuraavan täyden kalenterikuukauden lopussa.
        Irtisanominen tulee tehdä kirjallisesti Markku-sovelluksen kautta.
        Kaikki irtisanomishetkeen mennessä tehdyt tai irtisanomisaikana tehtävät
        ja muut jo sovitut työt laskutetaan voimassa olevan hinnaston mukaisesti
        irtisanomisesta huolimatta.
      </Text>

      <Title order={5}>
        1.7. Sovellettava laki ja erimielisyyksien ratkaisu
      </Title>
      <Text size="sm">
        Tähän Sopimukseen sovelletaan Suomen lakia. Sopimuksesta aiheutuvat
        erimielisyydet pyritään ensisijaisesti ratkaisemaan osapuolten välisin
        neuvotteluin. Mikäli yhteisymmärrykseen ei päästä, ratkaistaan riidat
        Palveluntarjoajan kotipaikan käräjäoikeudessa.
      </Text>
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function TermsContent_20251001() {
  return (
    <>
      <Text size="sm" fw={500} c="dimmed">
        Voimassa 1.10.2025 alkaen
      </Text>

      <Text size="sm">
        Tämä sopimus (jäljempänä &quot;Sopimus&quot;) on tehty
        Markku.fi-palvelun (jäljempänä &quot;Palveluntarjoaja&quot;) ja palvelun
        tilanneen pientaloasunnon omistajan tai haltijan (jäljempänä
        &quot;Asiakas&quot;) välillä. Sopimus koskee Palveluntarjoajan tuottamia
        kiinteistön kunnossapito- ja huoltopalveluita (jäljempänä
        &quot;Palvelu&quot;) Asiakkaan määrittelemässä kohteessa.
      </Text>

      <Title order={4}>1. Yleiset ehdot</Title>

      <Title order={5}>1.1. Asiakkaan vastuut ja velvollisuudet</Title>
      <Text size="sm">
        Asiakkaalla tapahtuva alkukartoituskäynti on erittäin tärkeä onnistuneen
        yhteistyön kannalta. Sen perusteellaan saadaan huoltotöistä suunniteltua
        asiakkaalle parhaan arvon tuova kokonaisuus, jonka tuloksena Asiakkaan
        koti saadaan pidettyä ennakoivasti kunnossa ja mukavana asua.
        Alkukartoituksessa myös määritellään mahdolliset työn laajuudesta
        syntyvät kuukausimaksun päälle tulevat lisämaksut työtehtäväkohtaisesti.
      </Text>
      <Text size="sm">
        Asiakas vastaa, että kaikkiin sopimuksen mukaisiin työkohteisiin on
        esteetön ja turvallinen pääsy sovittuina palveluaikoina. Asiakkaan
        velvollisuus on ilmoittaa Markku-sovelluksen kautta kaikista kohteessa
        tapahtuvista muutoksista, jotka voivat vaikuttaa Palvelun suorittamiseen
        (esim. uudet rakennelmat, istutukset, pihalla vapaana olevat
        lemmikkieläimet tai muut työskentelyyn vaikuttavat seikat). Haluamme
        varmistaa huoltohenkilöstölle eli Markuille mahdollisuuden turvalliseen
        työskentelyyn. Perustuen myös työturvallisuuslakiin pidätämme oikeuden
        olla tekemättä työtehtävää, jos se ei ole kohtuullisilla järjestelyillä
        mahdollista tehdä työturvallisesti. Asiakasta ei luonnollisesti silloin
        veloiteta ko. työstä, ellei työnteon este ilmene vasta kohteeseen
        saavuttaessa.
      </Text>
      <Text size="sm">
        Asiakkaalla on oikeus siirtää maksutta yhden (1) kerran jo sovittua
        seuraavaa Markku-pakettiinsa kuuluvaa huoltokäyntiä tai erikseen
        tilattua työtä, jos se tapahtuu viimeistään 2 viikkoa ennen sovittua
        tapahtumaa. Jos siirto tapahtuu lähempänä kuin 2 viikkoa sovitusta
        käynnistä tai useamman kerran samasta tapahtumasta, Palveluntarjoajalla
        on oikeus periä Asiakkaalta 50 euron lisämaksu per siirtokerta, paitsi
        alle 24 tuntia ennen tapahtumaa tehdystä siirrosta veloitus on 95
        €/siirtokerta. Uusia aika sovitaan yhdessä Asiakkaan ja
        Palveluntarjoajan kanssa käyttäen Markku-sovellusta.
      </Text>
      <Text size="sm">
        Asiakas ei saa suoraan solmia Markku.fi Palvelun ulkopuolisia työ- tai
        palvelusopimuksia Palveluntarjoajan henkilöstön tai sen käyttämien
        alihankkijoiden kanssa.
      </Text>

      <Title order={5}>1.2. Viestintä</Title>
      <Text size="sm">
        Kaikki Palveluun liittyvä viestintä, kuten palvelukäyntien sopiminen,
        palautteen antaminen ja mahdolliset reklamaatiot, tulee hoitaa
        Markku-sovelluksen viestintätoimintojen kautta. Tämä varmistaa
        tiedonkulun perillemenon, palvelutapahtumien dokumentoinnin ja
        laadukkaan asiakaspalvelun. Suorat yhteydenotot, kuten puhelinsoitot
        huoltohenkilöstölle, eivät ole sallittuja mm. jäljittävyyden ja
        työturvallisuuden takaamiseksi.
      </Text>

      <Title order={5}>1.3. Hinnoittelu, laskutus ja maksuehdot</Title>
      <Text size="sm">
        Kuukausimaksullinen Palvelu laskutetaan kuukausittain etukäteen
        Asiakkaan valitseman palvelupaketin mukaisesti. Asiakkaan erikseen
        tilaamat lisätyöt sekä kohteen laajuudesta tai muista olosuhteista
        johtuvat ja asiakkaan ennakkoon hyväksymät lisämaksut veloitetaan tehdyn
        työn jälkeen. Huoltotöihin liittyvät tai asiakkaan tilaamat materiaalit
        ja tarvikkeet veloitetaan toimituksen jälkeen. Osa palvelupaketteihin
        sisältyvistä töistä on niin suuritöisiä ja/tai vaatii kallista
        erikoiskalustoa, että edellytämme Asiakkaan sitoutumista sopimukseen
        tietyksi ajaksi ennen niiden toteuttamista. Tästä on maininta erikseen
        luvun 2 työtehtäväkohtaisissa kuvauksissa, jos vaatimus koskee ao.
        tehtävää.
      </Text>
      <Text size="sm">
        Maksuehto on 14 päivää netto. Kaikki hinnaston hinnat sisältävät
        voimassa olevan arvonlisäveron. Viivästyneestä maksusta peritään
        korkolain mukainen viivästyskorko.
      </Text>
      <Text size="sm">
        Palveluntarjoajalla on oikeus keskeyttää Palvelun tuottaminen tai purkaa
        Sopimus kokonaan, mikäli Asiakas ei ole suorittanut erääntyneitä
        laskujaan maksumuistutuksista huolimatta. Suoraveloitus luotto- (Credit)
        tai pankkikortilta (Debit) on lisämaksutonta. Paperilaskujen
        laskutuslisä on 10 €/lasku ja sähköpostilaskujen laskutuslisä 5 €/lasku.
      </Text>

      <Title order={5}>1.4. Hinnan- ja sisällönmuutokset</Title>
      <Text size="sm">
        Palveluntarjoaja pidättää oikeuden tarkistaa hintoja vuosittain. Hinnat
        on sidottu Tilastokeskuksen elinkustannusindeksiin (1951 = 100), mutta
        Palveluntarjoaja voi myös päättää sitä alemmasta korotuksesta.
        Palveluntarjoajalla on oikeus kehittää Palvelua ja tehdä muutoksia
        palvelupakettien sisältöön. Mikäli Asiakkaan tilaaman palvelupaketin
        sisältö muuttuu olennaisesti, ilmoitetaan siitä Asiakkaalle hyvissä
        ajoin. Samoin ilmoitetaan mahdollisesta muutoksen aiheuttamasta
        hinnankorotuksesta. Ilmoittaminen tapahtuu kirjallisesti
        Markku-sovelluksen kautta vähintään yksi (1) kuukautta ennen niiden
        voimaantuloa. Tällöin Asiakkaalla on oikeus irtisanoa Sopimus päättymään
        muutoksen voimaantulopäivään.
      </Text>
      <Text size="sm">
        Työtehtäväkohtaiset tarkennukset ja ehdot hintavaikutuksineen on
        esitetty sopimuksen luvussa 2.
      </Text>

      <Title order={5}>1.5. Vastuunrajoitus</Title>
      <Text size="sm">
        Palveluntarjoajan vastuu rajoittuu Palvelun suorittamisessa
        aiheutettuihin välittömiin esinevahinkoihin, jotka johtuvat
        Palveluntarjoajan tai sen alihankkijan todistetusta huolimattomuudesta.
        Palveluntarjoaja ei vastaa välillisistä tai epäsuorista vahingoista.
      </Text>
      <Text size="sm">
        Palveluntarjoaja ei myöskään vastaa vahingoista, jotka johtuvat
        kiinteistön rakenteellisista tai piilevistä virheistä, puutteellisista
        tai virheellisistä lähtötiedoista tai Asiakkaan laiminlyönneistä.
      </Text>

      <Title order={5}>1.6. Sopimuksen voimassaolo ja irtisanominen</Title>
      <Text size="sm">
        Sopimus on toistaiseksi voimassa oleva. Molemmilla osapuolilla on yhden
        (1) täyden kalenterikuukauden irtisanomisaika, jolloin palvelu päättyy
        irtisanomishetkeä seuraavan täyden kalenterikuukauden lopussa.
        Irtisanominen tulee tehdä kirjallisesti Markku-sovelluksen kautta.
        Kaikki irtisanomishetkeen mennessä tehdyt tai irtisanomisaikana tehtävät
        ja muut jo sovitut työt laskutetaan voimassa olevan hinnaston mukaisesti
        irtisanomisesta huolimatta. Lisäksi osasta suuritöisemmistä tehtävistä
        peritään lisämaksua, jos irtisanominen tapahtuu pian tehdyn työn jälkeen
        (katso tarkemmin luvusta 2. Työtehtäväkohtaiset tarkennukset ja ehdot).
      </Text>

      <Title order={5}>
        1.7. Sovellettava laki ja erimielisyyksien ratkaisu
      </Title>
      <Text size="sm">
        Tähän Sopimukseen sovelletaan Suomen lakia. Sopimuksesta aiheutuvat
        erimielisyydet pyritään ensisijaisesti ratkaisemaan osapuolten välisin
        neuvotteluin. Mikäli yhteisymmärrykseen ei päästä, ratkaistaan riidat
        Palveluntarjoajan kotipaikan käräjäoikeudessa.
      </Text>

      <Title order={4}>2. Työtehtäväkohtaiset tarkennukset ja ehdot</Title>
      <Text size="sm">
        Tässä osiossa on eritelty kuukausimaksullisiin palvelupaketteihin
        kuuluvat tehtävät. Eri pakettivaihtoehtoihin ja Asiakkaan tilaamaan
        pakettiin kuuluvat tehtävät on lueteltu markku.fi sivustolla ja
        asiakkaan Markku-sovelluksessa.
      </Text>

      <Title order={5}>2.1. Alkukartoituskäynti</Title>
      <Text size="sm">
        Alkukartoitus tehdään jokaiselle uudelle Asiakkaalle mahdollisimman pian
        Palvelun tilauksesta. Käynnillä lisätään Markku-sovellukseen puuttuvat
        tiedot kiinteistöstä ja siellä olevista koneista ja laitteista, joilla
        on merkitystä huoltotöiden toteutukseen. Tässä vaiheessa myös
        tarkennetaan mahdolliset lisäveloitukset johtuen kohteen vaatimasta
        työmäärästä ja työskentelyolosuhteista. Asiakkaalla on tässä vaiheessa
        halutessaan vielä oikeus perua kauppa tai muuttaa sopimukseen kuuluvaa
        sisältöä.
      </Text>

      <Title order={5}>2.2. Sähköinen huoltokirja</Title>
      <Text size="sm">
        Asiakkaat saavat veloituksetta käyttöönsä Palveluntarjoajan toteuttaman
        sähköisen huoltokirjan, johon dokumentoidaan kaikki Palveluntarjoajan
        toteuttamat työt ja käynnit. Asiakkaalla on oikeus kirjata huoltokirjaan
        myös itse toteuttamiaan töitä ja kolmansilta osapuolilta tilaamiaan
        töitä. Jos Asiakas irtisanoo Markku-sopimuksen, huoltokirja ja sinne
        tehdyt tallennukset jäävät kuitenkin edelleen Asiakkaan käyttöön. Jos
        Palveluntarjoaja lopettaa Markku-sovelluksen ja/tai sähköisen
        huoltokirjan tarjoamisen, Asiakkaalla on oikeus saada itselleen
        digitaalisessa muodossa talteen huoltokirjassa olevat tietonsa.
      </Text>

      <Title order={5}>2.3. Vuotovahingon hätäavun hälytysvalmius 24/7</Title>
      <Text size="sm">
        Vesivahingon sattuessa asiakkaalla on mahdollisuus Markku-sovelluksen
        kautta hälyttää apua 24/7 vahingon tutkimiseksi ja
        vahingontorjuntatöiden aloittamiseksi. Varsinaiset vuodon syiden ja
        vahinkojen selvittämisestä ja vauriokorjausten toteuttamisesta
        aiheutuneet kustannukset veloitetaan erikseen. Nämä toteutetaan ja
        veloitetaan kolmannen osapuolen toimesta, ellei muuta sovita Asiakkaan
        ja Palveluntarjoajan välillä.
      </Text>

      <Title order={5}>2.4. Ilmanvaihtokoneen suodattimien vaihto</Title>
      <Text size="sm">
        Osassa Markku-paketeista hintaan sisältyy yhden (1) ilmanvaihtokoneen
        suodattimien vaihto kaksi (2) kertaa vuodessa. Jos käytetään
        Palveluntarjoajan suodattimia, ne veloitetaan erikseen toteutuman
        mukaan. Ilmanvaihtokone myös imuroidaan sisältä vaihdon yhteydessä.
        Ilmanvaihtokoneelle pitää olla vapaa pääsy ja edessä tilaa toteuttaa
        työtehtävä turvallisesti.
      </Text>

      <Title order={5}>2.5. Tulo- ja poistoilmaventtiilien puhdistus</Title>
      <Text size="sm">
        Tulo- ja poistoilmaventtiilit puhdistetaan kohteeseen soveltuvalla
        menetelmällä yhden (1) kerran vuodessa. Kuukausihintaan sisältyy
        enintään kymmenen (10) venttiilin imurointi. Lisämaksu seuraavista
        venttiileistä on 10 €/kpl. Venttiileille pitää olla vapaa pääsy
        työskentelemään seisten tai A-tikkaiden avulla. Mikäli työssä tarvitaan
        telineitä, niiden kustannukset veloitetaan erikseen.
      </Text>

      <Title order={5}>2.6. Liesituulettimen suodattimen vaihto tai pesu</Title>
      <Text size="sm">
        Osassa Markku-paketeista hintaan sisältyy liesituulettimen suodattimen
        pesu tai vaihto yhden (1) kerran vuodessa. Kuukausihintaan sisältyy yksi
        (1) liesituuletin. Lisämaksu seuraavista liesituulettimista on 50 €/kpl.
        Suodattimien pesu tapahtuu asiakkaan altaassa tai astianpesukoneessa
        käynnin aikana. Jos suodattimia vaihdetaan uusiin ja käytetään
        Palveluntarjoajan suodattimia, ne veloitetaan erikseen toteutuman
        mukaan.
      </Text>

      <Title order={5}>
        2.7. Märkätilojen silikonien ja laattasaumojen tarkastus
      </Title>
      <Text size="sm">
        Palveluun sisältyy kodin märkätilojen silikoni- ja laattasaumojen kunnon
        tarkastus kerran vuodessa silmämääräisesti. Tarkastettavien tilojen
        pintojen tulee olla kuivat tarkastuksen aikana. Palvelutoimittaja ei
        vastaa puutteellisista vesieristyksistä tms., joita ei voida silmin
        havaita.
      </Text>

      <Title order={5}>
        2.8. Lattiakaivojen puhdistus ja suojaverkon vaihto
      </Title>
      <Text size="sm">
        Palvelun kuukausihintaan sisältyy enintään kolmen (3) lattiakaivon
        puhdistus ja suojaverkon vaihto (jos se kaivon tyypin vuoksi on
        soveltuvaa) neljä (4) kertaa vuodessa. Lisämaksu seuraavista
        lattiakaivoista on 25 €/kpl. Jos käytetään Palveluntarjoajan
        suodattimia, ne veloitetaan erikseen toteutuman mukaan. Lattiakaivoille
        pitää olla vapaa pääsy. Ammeiden tai kalusteiden alla olevia kaivoja ei
        puhdisteta.
      </Text>

      <Title order={5}>
        2.9. Palovaroittimien testaus ja paristojen vaihto
      </Title>
      <Text size="sm">
        Palvelun kuukausihintaan sisältyy enintään viiden (5) palovaroittimien
        toimivuuden testaus ja paristojen vaihto tarvittaessa yhden (1) kerran
        vuodessa. Lisämaksu seuraavista palovaroittimista on 5 €/kpl.
        Varoittimille pitää olla vapaa pääsy seisten tai A-tikkaiden avulla.
        Mikäli työssä tarvitaan telineitä, niiden kustannukset veloitetaan
        erikseen. Jos paristo joudutaan vaihtamaan ja käytetään
        Palveluntarjoajan paristoja tai jos joudutaan hankkimaan uusi
        palovaroitin, ne veloitetaan erikseen toteutuman mukaan.
      </Text>

      <Title order={5}>2.10. Lämpöpatterien säätö</Title>
      <Text size="sm">
        Palvelun kuukausihintaan sisältyy enintään kahdeksan (8) lämpöpatterin
        säätö ja ilmaus tarvittaessa. Lisämaksu seuraavista pattereista on 10
        €/kpl.
      </Text>

      <Title order={5}>2.11. Salaojakaivojen tarkastus</Title>
      <Text size="sm">
        Osassa Markku-paketeista hintaan sisältyy talon salaojakaivojen
        tarkistus, jolla varmistetaan, ettei veden kulku putkistoon ole estynyt
        lietteen tai roskien vuoksi. Tarkistus tehdään joka toinen vuosi.
        Asiakas vastaa siitä, että salaojakaivojen kannet ovat näkyvissä ja
        avattavissa, ja että niihin on turvallinen pääsy. Katso myös kohta 2.23
        &quot;Salaoja- ja sadevesiviemärien huuhtelu ja kaivojen
        puhdistus&quot;.
      </Text>

      <Title order={5}>2.12. Sadevesikourujen puhdistus</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy enintään 40 metriä
        sadevesikourujen puhdistusta maasta käsin toteutettuna ränni-imurin
        avulla kaksi (2) kertaa vuodessa (keväällä ja syksyllä). Ylimenevältä
        osalta veloitus on 40 € / alkava 10 metriä. Mikäli työtä ei voida
        turvallisesti suorittaa maasta käsin kohteen korkeuden, kaltevuuden tai
        muiden esteiden vuoksi ja työ vaatii esimerkiksi henkilönostimen käyttöä
        tai toisen työntekijän läsnäoloa työturvallisuuden varmistamiseksi,
        arvioidaan tästä aiheutuva lisäkustannus kohteen alkukartoituksen
        yhteydessä ja sovitaan Asiakkaan kanssa erikseen. Samoin mikäli
        vesikouru on ollut puhdistamatta pitkään ennen Markku-sopimuksen
        alkamista, jolloin se on merkittävästi normaalia hitaampaa, voidaan
        ensimmäisestä Palveluntarjoajan toteuttamasta puhdistuksesta veloittaa
        lisämaksu tuntihinnaston mukaisesti.
      </Text>
      <Text size="sm">
        Kouruista poistettava aines jää asiakkaalle kompostoitavaksi tai muuten
        hävitettäväksi ellei muuta sovita. Mahdollisesta jätteen poisvientiin
        kuluvasta työajasta veloitetaan toteutuneen mukaan voimassa olevan
        hinnaston mukaisesti, samoin mahdollinen jätemaksu.
      </Text>
      <Text size="sm">
        Jos sadevesikourujen puhdistus kuuluu Asiakkaan pakettiin, edellytämme
        että Asiakas sitoutuu sopimukseen vähintään 12 kuukauden ajaksi. Jos
        Asiakas irtisanoo sopimuksen ennen sitä, veloitetaan jo toteutettuihin
        kourujen puhdistuksiin kuluneesta ajasta jälkikäteen 50 % voimassa
        olevan hinnastomme mukaisesti. Työhön kulunut aika on todennettavissa
        Markku-sovelluksesta.
      </Text>

      <Title order={5}>2.13. Hajulukkojen puhdistus</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy enintään neljän (4)
        vesialtaiden alla sijaitsevien hajulukkojen puhdistus joka toinen vuosi.
        Lisämaksu seuraavista hajulukoista on 15 €/kpl. Asiakas vastaa siitä,
        että hajulukoille on vapaa pääsy (tavarat poistettu edestä).
      </Text>

      <Title order={5}>2.14. Alkusammuttimen vaihto</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy yhden (1) 6 kg:n
        alkusammuttimen vaihto tarkastettuun sammuttimeen kahden (2) vuoden
        välein. Asiakas vastaa ensimmäisen sammuttimen hankinnasta itse tai sen
        voi ostaa Palveluntarjoajalta. Markku-huoltohenkilönne vie sammuttimen
        vuosittain tarkastettavaksi ja jättää samalla käynnillä samanlaisen 6
        kg:n sammuttimen Asiakkaalle, jotta kodissa on aina toimiva ja lain
        mukaisesti tarkastettu sammutin.
      </Text>

      <Title order={5}>
        2.15. Keskuspölynimurin tyhjennys ja suodattimen vaihto
      </Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy keskuspölynimurin
        säiliön tyhjennys ja suodattimen vaihto kaksi (2) kertaa vuodessa.
        Säiliön sisältö tyhjennetään lähtökohtaisesti asiakkaan jäteastiaan. Jos
        sisältö viedään pois Palveluntarjoajan toimesta, poisvientiin kuluvasta
        työajasta veloitetaan toteutuneen mukaan voimassa olevan hinnaston
        mukaisesti, samoin mahdollinen jätemaksu.
      </Text>

      <Title order={5}>
        2.16. Avainten säilytys ja valmius ovien avaukseen
      </Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy kodin avainten
        säilytys, mikä mahdollistaa myös huoltohenkilön pääsyn kohteeseen ilman,
        että Asiakas on paikalla (sovittuna ajankohtana). Asiakas voi tilata
        myös oven avauksen, jos avaimet jää kotiin esimerkiksi lapsilta, jolloin
        työ laskutetaan erikseen kertamaksullisesti voimassa olevan hinnaston
        mukaisesti (katso kohta 2.24).
      </Text>

      <Title order={5}>2.17. Kiuaskivien vaihto</Title>
      <Text size="sm">
        Osassa Markku-paketeista hintaan sisältyy yhden (1) kiukaan kiuaskivien
        vaihto joka toinen vuosi. Jos käytetään Palveluntarjoajan kiuaskiviä, ne
        veloitetaan erikseen toteutuman mukaan. Jos Palveluntarjoaja vie vanhat
        kivet pois, poisvientiin kuluvasta työajasta veloitetaan toteutuneen
        mukaan voimassa olevan hinnaston mukaisesti, samoin mahdollinen
        jätemaksu (katso kohta 2.24).
      </Text>

      <Title order={5}>2.18. Ilmalämpöpumpun suodattimien puhdistus</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy yhden (1)
        ilmalämpöpumpun suodattimien puhdistus imuroimalla kerran kuukaudessa.
        Jos huoltohenkilö havaitsee tarpeen suodattimien vaihtoon, siitä
        ilmoitetaan Asiakkaalle, joka voi tilata vaihdon erikseen
        Palveluntarjoajalta tai ilmalämpöpumpun toimittajalta. Suodattimen
        vaihtotyö ja suodatin veloitetaan erikseen toteutuman mukaan.
      </Text>

      <Title order={5}>2.19. Katon pesu / puhdistus</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy enintään 200 m²:n
        kokoisen katon pesu tai muulla tavalla tehtävä puhdistus kolmen (3)
        vuoden välein. Lisämaksu suuremmista katoista on 50 €/alkava 20 m².
        Puhdistusmenetelmä valitaan kattomateriaalin mukaan niin, ettei
        pintamateriaaliin synny vaurioita. Pesu on myös mahdollista tilata
        erikseen, jos Palveluntarjoajan tarkastuksen yhteydessä tai asiakkaan
        itse havaitessa se todetaan tarpeelliseksi. Veloitus on tällöin
        tuntiperusteinen.
      </Text>
      <Text size="sm">
        Jos katon pesu tai muulla tavalla tapahtuva puhdistus kuuluu Asiakkaan
        pakettiin, edellytämme että Asiakas sitoutuu sopimukseen vähintään 12
        kuukauden ajaksi. Jos Asiakas irtisanoo sopimuksen ennen sitä,
        veloitetaan jo toteutettuihin kattojen pesuihin/puhdistuksiin kuluneesta
        ajasta jälkikäteen 50 % voimassa olevan tuntihinnastomme mukaisesti.
        Työhön kulunut aika on todennettavissa Markku-sovelluksesta.
      </Text>

      <Title order={5}>2.20. Märkätilojen silikonien vaihto</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy märkätilojen
        (kylpyhuone, wc, keittiö) silikonisaumojen vaihto enintään 10 metrin
        pituudelta viiden (5) vuoden välein (tarvittaessa). Lisämaksu isommasta
        määrästä on 25 €/m. Vaihto on myös mahdollista tilata erikseen, jos
        Palveluntarjoajan tarkastuksen yhteydessä tai asiakkaan itse havaitessa
        se todetaan tarpeelliseksi. Veloitus on tällöin tuntiperusteinen.
      </Text>
      <Text size="sm">
        Jos silikonien vaihto kuuluu Asiakkaan pakettiin, edellytämme että
        Asiakas sitoutuu sopimukseen vähintään 24 kuukauden ajaksi. Jos Asiakas
        irtisanoo sopimuksen ennen sitä, veloitetaan jo toteutettuihin
        silikonien vaihtoihin kuluneesta ajasta jälkikäteen 50 % voimassa olevan
        tuntihinnastomme mukaisesti. Työhön kulunut aika on todennettavissa
        Markku-sovelluksesta.
      </Text>

      <Title order={5}>
        2.21. Ilmanvaihtokanavien puhdistus ja ilmastoinnin säätö
      </Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy enintään 200 m²:n
        talon ilmanvaihtokanaviston puhdistus sekä sen jälkeen ilmanvaihdon
        toimivuuden mittaus ja säätö viiden (5) vuoden välein. Lisämaksu
        suuremmista taloista on 100 €/alkava 50 m². Työ on myös mahdollista
        tilata erikseen, jos Palveluntarjoajan tarkastuksen yhteydessä tai
        asiakkaan itse havaitessa se todetaan tarpeelliseksi. Veloitus on
        tällöin kertamaksullinen ja tarjousperusteinen.
      </Text>
      <Text size="sm">
        Jos ilmanvaihtokanavien puhdistus kuuluu Asiakkaan pakettiin,
        edellytämme että Asiakas sitoutuu sopimukseen vähintään 24 kuukauden
        ajaksi. Jos Asiakas irtisanoo sopimuksen ennen sitä, veloitetaan jo
        toteutettuihin puhdistuksiin/säätöihin kuluneesta ajasta jälkikäteen 50
        % voimassa olevan tuntihinnastomme mukaisesti. Työhön kulunut aika on
        todennettavissa Markku-sovelluksesta.
      </Text>

      <Title order={5}>2.22. Nuohous</Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy kahden (2) hormin ja
        tulipesän nuohous kerran vuodessa. Jos nuohottavaa on tätä enemmän,
        annetaan siitä kiinteähintainen tarjous kohteen alkukartoituksen
        yhteydessä tai Asiakkaan pyytäessä sitä erikseen.
      </Text>

      <Title order={5}>
        2.23. Salaoja- ja sadevesiviemärien huuhtelu ja kaivojen puhdistus
      </Title>
      <Text size="sm">
        Osassa Markku-paketeista kuukausihintaan sisältyy enintään 200 m²:n
        talon salaoja- ja sadevesiviemärien ja kaivojen puhdistus viiden (5)
        vuoden välein. Lisämaksu isompien talojen osalta on 100 €/alkava 50 m².
        Työ on myös mahdollista tilata erikseen, jos Palveluntarjoajan
        tarkastuksen yhteydessä tai asiakkaan itse havaitessa se todetaan
        tarpeelliseksi. Veloitus on tällöin kertamaksullinen ja
        tarjousperusteinen.
      </Text>
      <Text size="sm">
        Jos salaoja- ja sadevesiviemärien ja kaivojen puhdistus Asiakkaan
        pakettiin, edellytämme että Asiakas sitoutuu sopimukseen vähintään 24
        kuukauden ajaksi. Jos Asiakas irtisanoo sopimuksen ennen sitä,
        veloitetaan jo toteutettuihin puhdistuksiin kuluneesta ajasta
        jälkikäteen 50 % voimassa olevan tuntihinnastomme mukaisesti. Työhön
        kulunut aika on todennettavissa Markku-sovelluksesta.
      </Text>

      <Title order={5}>
        2.24. Muut työt ja työtehtäväkohtaiset työmäärän laajennukset
      </Title>
      <Text size="sm">
        Töistä, joita ei ole edellä mainittu, annetaan asiakkaalle tarjous, joka
        voi perustua tuntiveloitukseen 78 €/h (sis. alv 25,5 %) tai kiinteään,
        tarjouksessa annettavaan hintaan. Samaa tuntihintaa käytetään
        tapauksissa, jossa kohteen koko/laajuus ylittää kuukausihintaan kuuluvan
        rajan tai työhön sisältyy kuljetuksia (rajat ja ehdot mainittu kunkin
        työn kuvauksen kohdalla). Jos Asiakas haluaa työn tapahtuvan
        Palveluntarjoajan normaalin työajan ma-pe 07:30 – 17:00 ulkopuolella,
        siitä on sovittava erikseen. Normaalin työajan ulkopuolella tehtävistä
        töistä veloitetaan korotettu maksu.
      </Text>
    </>
  )
}

export const TERMS_VERSIONS: Record<string, TermsVersion> = {
  '2025-11-03': {
    pdfUrl:
      '/documents/sopimusehdot-2025-11-03-9509eb07-5c17-48d1-bd21-cf4be8d59c47.pdf',
    effectiveDate: '3.11.2025',
    content: <TermsContent_20251103 />,
  },
  '2025-10-01': {
    pdfUrl: '/documents/sopimusehdot-2025-10-01.pdf',
    effectiveDate: '1.10.2025',
    content: <TermsContent_20251001 />,
  },
}

export function getTermsVersion(version?: string | null): TermsVersion {
  const versionToUse = version || CURRENT_TERMS_VERSION
  const termsVersion = TERMS_VERSIONS[versionToUse]

  if (!termsVersion) {
    console.error(
      `Terms version ${versionToUse} not found, falling back to current`,
    )
    return TERMS_VERSIONS[CURRENT_TERMS_VERSION]
  }

  return termsVersion
}
